import { Box, Paper, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import CheckIcon from "@mui/icons-material/Check";

type ImportModeCardProps = {
  icon: ReactNode;
  iconBgcolor: string;
  iconColor: string;
  title: string;
  subtitle: string;
  isSelected: boolean;
  onSelect: () => void;
};

export const ImportModeCard = ({
  icon,
  iconBgcolor,
  iconColor,
  title,
  subtitle,
  isSelected,
  onSelect,
}: ImportModeCardProps) => (
  <Paper
    variant="outlined"
    onClick={onSelect}
    sx={{
      flex: 1,
      borderRadius: "12px",
      p: 2,
      cursor: "pointer",
      transition: "all 0.2s",
      ...(isSelected && { borderColor: "#FF8D3F", bgcolor: "#FEF6EE" }),
      "&:hover": { borderColor: "#FF8D3F" },
    }}
  >
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minWidth={40}
        height={40}
        borderRadius="50%"
        bgcolor={iconBgcolor}
        sx={{ "& svg": { color: iconColor } }}
      >
        {icon}
      </Box>
      <Box flex={1}>
        <Typography fontSize={14} fontWeight={600} color="#101828">
          {title}
        </Typography>
        <Typography fontSize={12} color="#667085">
          {subtitle}
        </Typography>
      </Box>
      {isSelected && <CheckIcon sx={{ color: "#FF8D3F" }} fontSize="small" />}
    </Stack>
  </Paper>
);
